import React from 'react';

const ProcessContext = React.createContext(null);

export const ProcessProvider = ProcessContext.Provider;
export const ProcessConsumer = ProcessContext.Consumer;

export default ProcessContext;
